import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $string_builder from "../../gleam_stdlib/gleam/string_builder.mjs";
import { CustomType as $CustomType, makeError } from "../gleam.mjs";
import * as $attribute from "../lustre/attribute.mjs";

class Text extends $CustomType {
  constructor(x0) {
    super();
    this[0] = x0;
  }
}

class Element extends $CustomType {
  constructor(x0, x1, x2) {
    super();
    this[0] = x0;
    this[1] = x1;
    this[2] = x2;
  }
}

class ElementNs extends $CustomType {
  constructor(x0, x1, x2, x3) {
    super();
    this[0] = x0;
    this[1] = x1;
    this[2] = x2;
    this[3] = x3;
  }
}

export function element(tag, attrs, children) {
  return new Element(tag, attrs, children);
}

export function namespaced(namespace, tag, attrs, children) {
  return new ElementNs(tag, attrs, children, namespace);
}

export function text(content) {
  return new Text(content);
}

function attrs_to_string_builder(html, attrs) {
  return $list.fold(
    attrs,
    html,
    (html, attr) => {
      return $string_builder.append_builder(
        html,
        $attribute.to_string_builder(attr),
      );
    },
  );
}

function escape(loop$escaped, loop$content) {
  while (true) {
    let escaped = loop$escaped;
    let content = loop$content;
    let $ = $string.pop_grapheme(content);
    if ($.isOk() && $[0][0] === "<") {
      let xs = $[0][1];
      loop$escaped = escaped + "&lt;";
      loop$content = xs;
    } else if ($.isOk() && $[0][0] === ">") {
      let xs = $[0][1];
      loop$escaped = escaped + "&gt;";
      loop$content = xs;
    } else if ($.isOk() && $[0][0] === "&") {
      let xs = $[0][1];
      loop$escaped = escaped + "&amp;";
      loop$content = xs;
    } else if ($.isOk() && $[0][0] === "\"") {
      let xs = $[0][1];
      loop$escaped = escaped + "&quot;";
      loop$content = xs;
    } else if ($.isOk() && $[0][0] === "'") {
      let xs = $[0][1];
      loop$escaped = escaped + "&#x27;";
      loop$content = xs;
    } else if ($.isOk()) {
      let x = $[0][0];
      let xs = $[0][1];
      loop$escaped = escaped + x;
      loop$content = xs;
    } else if (!$.isOk()) {
      return escaped + content;
    } else {
      throw makeError(
        "case_no_match",
        "lustre/element",
        48,
        "escape",
        "No case clause matched",
        { values: [$] }
      )
    }
  }
}

export function map(element, f) {
  if (element instanceof Text) {
    let content = element[0];
    return new Text(content);
  } else if (element instanceof Element) {
    let tag = element[0];
    let attrs = element[1];
    let children = element[2];
    return new Element(
      tag,
      $list.map(attrs, (_capture) => { return $attribute.map(_capture, f); }),
      $list.map(children, (_capture) => { return map(_capture, f); }),
    );
  } else if (element instanceof ElementNs) {
    let tag = element[0];
    let attrs = element[1];
    let children = element[2];
    let namespace = element[3];
    return new ElementNs(
      tag,
      $list.map(attrs, (_capture) => { return $attribute.map(_capture, f); }),
      $list.map(children, (_capture) => { return map(_capture, f); }),
      namespace,
    );
  } else {
    throw makeError(
      "case_no_match",
      "lustre/element",
      64,
      "map",
      "No case clause matched",
      { values: [element] }
    )
  }
}

function children_to_string_builder(html, children) {
  return $list.fold(
    children,
    html,
    (html, child) => {
      return $string_builder.append_builder(html, to_string_builder(child));
    },
  );
}

export function to_string_builder(element) {
  if (element instanceof Text) {
    let content = element[0];
    return $string_builder.from_string(escape("", content));
  } else if (element instanceof Element) {
    let tag = element[0];
    let attrs = element[1];
    let children = element[2];
    let _pipe = $string_builder.from_string("<" + tag);
    let _pipe$1 = attrs_to_string_builder(_pipe, attrs);
    let _pipe$2 = $string_builder.append(_pipe$1, ">");
    let _pipe$3 = children_to_string_builder(_pipe$2, children);
    return $string_builder.append(_pipe$3, ("</" + tag) + ">");
  } else if (element instanceof ElementNs) {
    let tag = element[0];
    let attrs = element[1];
    let children = element[2];
    let namespace = element[3];
    let _pipe = $string_builder.from_string("<" + tag);
    let _pipe$1 = attrs_to_string_builder(_pipe, attrs);
    let _pipe$2 = $string_builder.append(
      _pipe$1,
      (" xmlns=\"" + namespace) + "\"",
    );
    let _pipe$3 = $string_builder.append(_pipe$2, ">");
    let _pipe$4 = children_to_string_builder(_pipe$3, children);
    return $string_builder.append(_pipe$4, ("</" + tag) + ">");
  } else {
    throw makeError(
      "case_no_match",
      "lustre/element",
      94,
      "to_string_builder",
      "No case clause matched",
      { values: [element] }
    )
  }
}

export function to_string(element) {
  let _pipe = to_string_builder(element);
  return $string_builder.to_string(_pipe);
}
